module.exports = __webpack_public_path__ + "img/gallery-image-27.8bd84a2c.jpg";